import { RouteConfig } from 'vue-router';

import ClubAdd from '@/views/club/Add.vue';

export const addClubRoute: RouteConfig = {
  path: 'add',
  name: 'clubAdd',
  component: ClubAdd,
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.clubs.add',
      name: 'clubAdd'
    }
  }
};
